import {observer} from "mobx-react-lite";
import appStore from "../../../storage/AppStore";
import {useEffect, useState} from "react";
import clubStore from "../../../storage/ClubStore";
import systemStore from "../../../storage/SystemStore";
import {Link} from "react-router";
import {Card} from "primereact/card";
import {Divider} from "primereact/divider";

const Newbies = () => {
    const [newbies, setNewbies] = useState([]);
    useEffect(() => {
        clubStore.getNewbies().then(data => {
            setNewbies(data.newbies);
        }).catch(error => {
            systemStore.setError(error.message)
        })
    }, []);
    if (newbies.length === 0) {
        return null;
    }
    return (
        <Card className="attendance-card shadow-2 border-round">
    <div className="attendance-card-header">
        <span className="attendance-card-title">
            {appStore.tr.newbies}
        </span>
    </div>

    <Divider className="attendance-divider"/>

    {newbies.map(newbie => (
        <div key={newbie.month} className="attendance-month">
            <div className="attendance-month-title">
                {appStore.tr[newbie.month]}
            </div>

            <div className="attendance-list">
                {newbie.company_users.map(user => (
                    <div key={user.id} className="attendance-row">
                        <Link
                            to={`/manager/trainings/attendance/detail/${user.id}`}
                            className="attendance-link"
                        >
                            {user.title}
                        </Link>

                        <span className="attendance-count">
                            <strong>{user.attendance_count}</strong> / {user.total}
                        </span>
                    </div>
                ))}
            </div>

            <Divider className="attendance-divider spaced"/>
        </div>
    ))}
</Card>

    );
}
export default observer(Newbies)